var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _path2, _circle13, _circle14, _circle15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMemberInfoPlaceholderMan = function SvgMemberInfoPlaceholderMan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 158 68"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157.5,
    height: 68,
    fill: "#fff",
    rx: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3D8",
    d: "m64.703 63.266-1.016-1.172a1.262 1.262 0 0 0-1.914 0l-1.015 1.172c-.156.156-.313.234-.508.234a.71.71 0 0 1-.547-.234l-1.133-1.29a1.205 1.205 0 0 0-1.758-.038l-.078.078a.89.89 0 0 1-.625.234.867.867 0 0 1-.859-.86V51c0-4.14 3.36-7.5 7.5-7.5s7.5 3.36 7.5 7.5v10.39c0 .47-.43.86-.898.86a.89.89 0 0 1-.625-.234l-.079-.078a1.205 1.205 0 0 0-1.757.039l-1.133 1.289c-.156.156-.313.234-.508.234a.71.71 0 0 1-.547-.234M56.5 60.648c.977-.586 2.227-.39 3.008.508l.742.82.586-.703a2.537 2.537 0 0 1 3.789 0l.625.704.703-.82c.781-.9 2.031-1.055 3.047-.509V51c0-3.437-2.812-6.25-6.25-6.25A6.243 6.243 0 0 0 56.5 51zM61.188 51c0 .547-.43.938-.938.938-.547 0-.937-.391-.937-.938 0-.508.39-.937.937-.937a.95.95 0 0 1 .938.937m4.062.938c-.547 0-.937-.391-.937-.938 0-.508.39-.937.937-.937a.95.95 0 0 1 .938.937c0 .547-.43.938-.938.938"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3D8",
    d: "M118.25 54.375a1.11 1.11 0 0 1-1.125-1.125v-7.77c-3.832.528-6.75 3.833-6.75 7.77a7.86 7.86 0 0 0 7.875 7.875c3.938 0 7.242-2.918 7.77-6.75zm-1.125-10.055c.598-.07 1.125.457 1.125 1.055v7.875h7.875c.598 0 1.125.527 1.055 1.125a9 9 0 0 1-8.93 7.875c-4.992 0-9-4.008-9-9a9 9 0 0 1 7.875-8.93"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.25,
    cy: 53,
    r: 1,
    fill: "#CDD3D8"
  })));
};
export default SvgMemberInfoPlaceholderMan;